module.exports = __webpack_public_path__ + "img/112.d90389f1.jpg";